import React from 'react';
import { SearchContainer } from '../../components/TeamPermission/styles';
import { Icon, Button, Input, Table, Popover, Badge } from 'antd';
import { withTranslation } from 'react-i18next';
import { BATCHLIST_DATA_TABLE } from '../MailRoom/translationValues';
import { StatusTag } from '../MailRoom/dataTableStyles';

const NAMESPACES = ['BATCHLIST_DATA_TABLE'];

const DataTable = props => {
  const { tableData, t } = props;

  const getInputPlaceholder = (dataIndex, t) => {
    switch (dataIndex) {
      case 'fileName':
        return t(
          BATCHLIST_DATA_TABLE.HYBRID_MAIL_FILE_NAME.key,
          BATCHLIST_DATA_TABLE.HYBRID_MAIL_FILE_NAME.value,
        );
        break;
      case 'addressText':
        return t(
          BATCHLIST_DATA_TABLE.HYBRID_MAIL_ADDRESS.key,
          BATCHLIST_DATA_TABLE.HYBRID_MAIL_ADDRESS.value,
        );
        break;

      default:
        return '';
    }
  };

  const getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <SearchContainer style={{ padding: 8 }} mailRoom={true}>
        <Input
          className="searchInput"
          placeholder={`Search by ${getInputPlaceholder(dataIndex, t)}`}
          value={selectedKeys}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => {
            confirm();
          }}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => {
            clearFilters();
            confirm();
          }}
          size="small"
          style={{ width: 90 }}
        >
          Clear
        </Button>
      </SearchContainer>
    ),
    filterIcon: filtered => (
      <Icon type="search" style={{ color: filtered ? '#007480' : '#f2f2f2' }} />
    ),
  });

  const tableColumns = [
    {
      title: t(
        BATCHLIST_DATA_TABLE.HYBRID_MAIL_FILE_NAME.key,
        BATCHLIST_DATA_TABLE.HYBRID_MAIL_FILE_NAME.value,
      ),
      dataIndex: 'fileName',
      // ...getColumnSearchProps('fileName'),
    },
    {
      title: t(
        BATCHLIST_DATA_TABLE.HYBRID_MAIL_ADDRESS.key,
        BATCHLIST_DATA_TABLE.HYBRID_MAIL_ADDRESS.value,
      ),
      dataIndex: 'addressText',
      // ...getColumnSearchProps('addressText'),
      render: (text, record) => {
        return (
          <Popover placement="top" content={text.toString()} trigger="hover">
            {text}
          </Popover>
        );
      },
    },
    {
      title: 'Start Page',
      dataIndex: 'startPage',
    },

    {
      title: 'End Page',
      dataIndex: 'endPage',
    },

    {
      title: t(
        BATCHLIST_DATA_TABLE.STATUS_COLUMN_NAME.key,
        BATCHLIST_DATA_TABLE.STATUS_COLUMN_NAME.value,
      ),
      dataIndex: 'status',
      render: (text, record) => {
        return (
          <StatusTag color={'#5cd65c'} backgroundColor={'#d6f5d6'}>
            <Badge color={'#5cd65c'} status={text?.toLowerCase().includes('queue') && 'processing'} />{' '}
            Success
          </StatusTag>
        );
      },
    },
  ];

  return (
    <Table
      rowKey={record => record.id}
      columns={tableColumns}
      dataSource={tableData}
      pagination={{
        hideOnSinglePage: true,
        total: tableData.length,
        defaultPageSize: 8,
      }}
      // onChange={(pagination, filters, sorter) => updateBatchDetails(pagination, filters, sorter)}
      // loading={loading}
    />
  );
};

export default withTranslation(NAMESPACES)(DataTable);
